class DeferredVideo extends HTMLElement {
  connectedCallback () {
    if (!this.videoElement) return
    if (this.currentPoster !== null) this.videoElement.poster = this.currentPoster

    if (window.Tentbox.canPlayVideo) {
      this.initObserver()
      window.addEventListener('resize', this.handleResize.bind(this))
    }
  }

  disconnectedCallback () {
    window.removeEventListener('resize', this.handleResize.bind(this))
  }

  initObserver () {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Load and play the video if it hasn't been loaded yet
          if (!this.hasAttribute('loaded')) {
            this.updateVideoSource()
            this.setAttribute('loaded', '')
          }
          if (this.videoElement.hasAttribute('playsinline')) {
            this.videoElement.play()
          }
        } else {
          // Pause the video when not intersecting
          this.videoElement.pause()
        }
      })
    }, {
      rootMargin: '200px',
    })

    observer.observe(this)
  }

  handleResize () {
    if (this.videoElement) {
      const currentSrc = this.videoElement.src
      const newSrc = this.currentSrc

      // Update video source only if it has changed
      if (currentSrc !== newSrc) {
        const wasPlaying = !this.videoElement.paused
        const currentTime = this.videoElement.currentTime
        this.videoElement.src = newSrc
        if (this.currentPoster !== null) this.videoElement.poster = this.currentPoster
        this.videoElement.currentTime = currentTime
        if (wasPlaying) {
          this.videoElement.play()
        }
      }
    }
  }

  updateVideoSource () {
    const src = this.currentSrc

    if (!src) {
      return console.error('No video source provided for deferred-video element')
    }

    this.videoElement.src = src
    if (this.currentPoster !== null) this.videoElement.poster = this.currentPoster
  }

  get videoElement () {
    return this.querySelector('video')
  }

  get currentSrc () {
    return this.mobileSrc !== null ? window.innerWidth > 768 ? this.desktopSrc : this.mobileSrc : this.desktopSrc
  }

  get currentPoster () {
    return this.mobilePoster !== null ? window.innerWidth > 768 ? this.desktopPoster : this.mobilePoster : this.desktopPoster
  }

  get desktopSrc () {
    return this.videoElement.dataset.desktopSrc || null
  }

  get mobileSrc () {
    return this.videoElement.dataset.mobileSrc || null
  }

  get desktopPoster () {
    return this.videoElement.dataset.desktopPoster || null
  }

  get mobilePoster () {
    return this.videoElement.dataset.mobilePoster || null
  }
}

if (!customElements.get('deferred-video')) {
  customElements.define('deferred-video', DeferredVideo)
}
